import { Divider, skinVars, Stack, Text3 } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import type { ITextListItemProps } from "../TextListItem";
import { TextListItem } from "../TextListItem";

interface IProps {
	sectionTitle: string;
	sectionItem: ITextListItemProps[];
	isLast?: boolean;
}

export const TextSectionList: React.FC<IProps> = observer((props) => {
	const { sectionItem, sectionTitle, isLast } = props;

	return (
		<Stack space={16}>
			<Text3 medium color={skinVars.colors.brand}>
				{sectionTitle}
			</Text3>
			{sectionItem.map((item, index) => (
				<TextListItem
					key={index}
					name={item.name}
					description={item.description}
					title={item.title}
					tooltipText={item.tooltipText}
				/>
			))}
			{!isLast && <Divider />}
		</Stack>
	);
});
